import { BasePropertyApi } from './base-api.interface';
import { getBackgroundColor } from './get-common-properties';
import { updateBackgroundColor } from './update-common-properties';

export const backgroundColorAPI: BasePropertyApi = {
  get: getBackgroundColor,
  update: updateBackgroundColor,
};
